module.exports = __webpack_public_path__ + "static/media/caregiver-mobile-2.ab5713d8.png";